import React, { useState } from 'react';
import { Button, Modal, Input, message, TreeSelect } from 'antd';
import { insertTemaArea, getAreas } from '../../services/areaService';
import './modal.css'
const ModalCreateTema = ({ onTemaCreated }) => {
  const [loading, setLoading] = useState(false);
  const [openTemaModal, setOpenTemaModal] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [valueArea, setValueArea] = useState();
  const [temaDescripcion, setTemaDescripcion] = useState('');
  const [temaLabel, setTemaLabel] = useState('');

  const fetchAreas = async () => {
    setLoading(true);
    try {
      const response = await getAreas();
      if (Array.isArray(response)) {
        const AreasData = response.map((area) => ({
          title: area.descripcion,
          key: area.id,
          value: area.id,
        }));
        setTreeData(AreasData);
      } else {
        message.error('Los datos no se han podido obtener.');
      }
    } catch (error) {
      console.log(error);
      message.error('Error al obtener los datos de las áreas.');
    } finally {
      setLoading(false);
    }
  };

  const onChangeArea = (newValue) => {
    setValueArea(newValue);
  };

  const handleTemaOk = async () => {
    setLoading(true);
    try {
      const temaData = {
        descripcion: temaDescripcion,
        label: temaDescripcion,
        area_tematica_id: valueArea,
      };
      await insertTemaArea(temaData);
      message.success('Tema creado correctamente.');
      setOpenTemaModal(false);
      // Reset form
      setTemaDescripcion('');
      setValueArea(null);
      onTemaCreated();
    } catch (error) {
      message.error('Error al insertar el tema.');
    } finally {
      setLoading(false);
    }
  };

  const handleTemaCancel = () => {
    setOpenTemaModal(false);
  };

  return (
    <>
      <Button className='botonTema' type="primary" onClick={() => { setOpenTemaModal(true); fetchAreas(); }}>
        Crear
      </Button>
      <Modal
        open={openTemaModal}
        title="Crear Tema"
        onOk={handleTemaOk}
        onCancel={handleTemaCancel}
        footer={[
          <Button key="back" onClick={handleTemaCancel}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={handleTemaOk}>
            Crear
          </Button>,
        ]}
      >
        <TreeSelect
          showSearch
          style={{ width: '100%', marginBottom: 10 }}
          value={valueArea}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          placeholder="Selecciona un Área"
          allowClear
          treeDefaultExpandAll
          onChange={onChangeArea}
          treeData={treeData}
        />
        <Input
          placeholder="Nombre del Tema"
          value={temaDescripcion}
          onChange={(e) => setTemaDescripcion(e.target.value)}
          style={{ marginBottom: 10 }}
        />

      </Modal>
    </>
  );
};

export default ModalCreateTema;
